import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FileFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2v5.054c0 .424 0 .837.046 1.177.051.383.177.82.54 1.183s.8.489 1.184.54c.34.046.752.046 1.176.046H20v6c0 2.828 0 4.243-.879 5.121C18.243 22 16.828 22 14 22h-4c-2.828 0-4.243 0-5.121-.879C4 20.243 4 18.828 4 16V8c0-2.828 0-4.243.879-5.121C5.757 2 7.172 2 10 2zm2 .005V7c0 .5.002.774.028.964v.007l.008.001c.19.026.464.028.964.028h4.995c-.01-.412-.043-.684-.147-.937-.152-.367-.441-.657-1.02-1.235l-2.656-2.656c-.578-.578-.867-.868-1.235-1.02-.253-.105-.525-.137-.937-.147", clipRule: "evenodd" })));
}
const FileFill = forwardRef(_FileFill);
export { FileFill };
